import React, { useEffect } from "react";

import Slider from "rc-slider";
import "rc-slider/assets/index.css";

import {
  PauseIcon,
  PlayArrowIcon,
  SkipNextIcon,
  SkipPreviousIcon,
  VolumeDownIcon,
  VolumeOffIcon,
  VolumeUpIcon,
} from "../icons/Icons";

export default function Controls({
  playNextOrPrevious,
  pauseOrResume,
  pausedBtn,
  currentTime,
  muteOrUnmute,
  handleTimeChange,
  volumeNumber,
  handleVolumeChange,
  setCurrentTime,
  audio,
}) {
  return (
    <>
      <div className="player-container">
        <div className="player-buttons-container">
          <div
            className="SkipPreviousIcon"
            onClick={() => playNextOrPrevious("prev")}
          >
            <SkipPreviousIcon />
          </div>
          <div
            id="pauseOrResume"
            className="player-playIcon"
            onClick={() => pauseOrResume()}
          >
            {pausedBtn ? (
              <PauseIcon/>
            ) : (
              <PlayArrowIcon/>
            )}
          </div>

          <div onClick={() => playNextOrPrevious("next")}>
            <SkipNextIcon />
          </div>
        </div>
        <div className="player-sliders-container">
          <p className="show-currentTime">{`0${Math.floor(
            currentTime / 60
          )}:${Math.floor((currentTime / 10) % 6)}${Math.floor(
            currentTime % 10
          )}`}</p>
          <div className="player-time-slider-container">
            <Slider
              railStyle={{ background: "#777", height: 2 }}
              handleStyle={{
                border: "none",
                height: 12.5,
                width: 12.5,
                marginTop: -5.5,
                backgroundColor: "#ededee",
              }}
              trackStyle={{ backgroundColor: "#ededee", height: 2.1 }}
              min={0}
              max={audio && audio.duration}
              value={currentTime}
              onChange={(newValue) => handleTimeChange(newValue)}
            />
          </div>
          {audio ? (
            audio.duration > 0 ? (
              <p className="show-full-time">{`0${
                Math.floor(audio.duration / 60) -
                Math.floor(audio.duration / 60 / 60)
              }:${Math.round(audio.duration % 60)}`}</p>
            ) : (
              <p className="show-full-time">00:00</p>
            )
          ) : (
            <p className="show-full-time">00:00</p>
          )}
          <div onClick={muteOrUnmute} className="volume-icon">
            {volumeNumber === 0 || (audio && audio.volume === 0) ? (
              <VolumeOffIcon />
            ) : volumeNumber < 0.5 && volumeNumber > 0 ? (
              <VolumeDownIcon />
            ) : (
              <VolumeUpIcon />
            )}
          </div>
          <div className="player-volume-slider-container">
            <Slider
              railStyle={{ background: "#4dae9a", height: 2 }}
              handleStyle={{
                border: "none",
                height: 12.5,
                width: 12.5,
                marginTop: -5.5,
                backgroundColor: "#04dc82",
              }}
              trackStyle={{ backgroundColor: "#05d186", height: 2.1 }}
              min={0}
              max={100}
              value={volumeNumber * 100}
              onChange={(newValue) => handleVolumeChange(newValue)}
            />
          </div>
        </div>
      </div>
    </>
  );
}
